import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSiteStoreAddress: false,
  isClientStoreAddress: false,
};

const siteAddressSlice = createSlice({
  name: 'siteAddresses',
  initialState,
  reducers: {
    setStoreSiteAddress(state, { payload }) {
      state.isSiteStoreAddress = payload;
    },
    setClientSiteAddress(state, { payload }) {
      state.isClientStoreAddress = payload;
    },
  },
});

export const { setStoreSiteAddress, setClientSiteAddress } =
  siteAddressSlice.actions;
export const siteAddressReducer = siteAddressSlice.reducer;
